import React, { useState } from 'react';
import PropTypes from 'prop-types';

import SrCard from 'client/components/SrCard/SrCard';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import useConcessionsProController from 'client/components/SrConcessionsPro/useConcessionsProController';
import SrConcessionsBanner from 'client/components/SrConcessionsBanner/SrConcessionsBanner';
import SrBox from 'client/components/SrBox';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_RED_INVERTED,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';

import './SrConcessionsPro.less';

const SrConcessionsPro = ({ concession, rentPrice }) => {
  const [endConcessionModalOpen, setEndConcessionModalOpen] = useState(false);
  const controller = useConcessionsProController({ concession });

  return (
    <SrCard styleName='SrConcessionsPro'>
      <SrFlex styleName='headerContainer'>
        <SrBox styleName='starIconContainer'>
          <SrBox styleName='starIcon' />
        </SrBox>
        <SrText
          fontSize='30px'
          font='greycliff'
          weight='800'
          lineHeight='38px'
          letterSpacing='1px'
        >
          Concession Pro&trade;
        </SrText>
      </SrFlex>
      <SrFlex
        align='baseline'
      >
        <SrText
          font='greycliff'
          weight='700'
          fontSize='22px'
          color={controller.color}
        >
          {controller.text}
        </SrText>
        <SrText
          font='greycliff'
          color='grey'
          weight='700'
          fontSize='16px'
          paddingLeft='16px'
        >
          {controller.expirationText}
        </SrText>
      </SrFlex>
      <SrBox
        margin='12px 0px'
      >
        <SrConcessionsBanner
          concession={concession}
          rentPrice={rentPrice}
        />
      </SrBox>
      {controller.endConcessionCtaActive && (
        <SrButton
          onClick={() => setEndConcessionModalOpen(true)}
          theme={SR_BUTTON_THEME_ADOBE_RED_INVERTED}
        >
          End concession
        </SrButton>
      )}
      {endConcessionModalOpen && (
        <SrSimpleMessageModal
          iconUrl='/images/warning-triangle-orange-large.svg'
          headline='End special early?'
          theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
          message={
            <span>
              You are about to end the rent concession earlier than the stated duration.
              <br />
              <br />
              {
                'Be aware that this action may result in confusion or disappointment for interested ' +
                'parties who were expecting the concession to be available for the full duration.'
              }
            </span>
          }
          customCtas={[
            <SrBox key='endSpecial'>
              <SrButton
                onClick={() => {
                  controller.onEndConcessionSubmit()
                    .then(() => setEndConcessionModalOpen(false));
                }}
                theme={SR_BUTTON_THEME_ADOBE_RED_INVERTED}
              >
                End special
              </SrButton>
            </SrBox>,
            <SrBox key='cancel' marginTop='16px'>
              <SrButton
                onClick={() => setEndConcessionModalOpen(false)}
                theme={SR_BUTTON_THEME_ADOBE_GREY}
              >
                Cancel
              </SrButton>
            </SrBox>,
          ]}
          maxWidth={375}
        />
      )}
    </SrCard>
  );
};

SrConcessionsPro.propTypes = {
  concession: PropTypes.object.isRequired,
  rentPrice: PropTypes.number.isRequired,
};

SrConcessionsPro.displayName = 'SrConcessionsPro';

export default SrConcessionsPro;
